import { render } from "./product-sale-badge.vue?vue&type=template&id=65bd4d52"
import script from "./product-sale-badge.vue?vue&type=script&lang=js"
export * from "./product-sale-badge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__